export const CUSTOMER_CARE_NUMBER = '1800-267-4444';
export const CUSTOMER_CARE_NUMBER_MAN = '1800-267-88888';
export const CUSTOMER_CARE_EMAIL_MAN = 'support@nykaaman.com';
export const TIMING = '(All days, 8 AM to 10 PM)';
export const WRITE_TO_US = 'or write to us at';
export const CALL_US = 'for any help, you may call us at';

export const LINKS = {
  Nykaa: [
    {
      displayAs: 'Who are we?',
      redirectTo: '/who_are_we/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Careers',
      redirectTo: '/who_are_we/lp#wwrcopen',
    },
    {
      displayAs: 'Authenticity',
      redirectTo:
        '/authenticity-nykaa-guarantee/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Press',
      redirectTo: '/who_are_we/lp#wwrpress',
    },
    {
      displayAs: 'Testimonials',
      redirectTo: '/who_are_we/lp#wwrtestimonial',
    },
    {
      displayAs: 'Nykaa CSR',
      redirectTo: '/nykaa-csr/lp',
    },
    {
      displayAs: 'Sustainability',
      redirectTo: 'sustainability/lp',
    },
    {
      displayAs: 'Responsible Disclosure',
      redirectTo: '/responsible-disclosure/lp',
    },
    {
      displayAs: 'Investor Relations',
      redirectTo: '/investor-relations',
    },
  ],
  Help: [
    {
      displayAs: 'Contact Us',
      redirectTo:
        'https://www.nykaa.com/gateway-api/omsApis/helpCenter?domain=NYKAA',
    },
    {
      displayAs: 'Frequently asked questions',
      redirectTo:
        'https://www.nykaa.com/gateway-api/omsApis/helpCenter?domain=NYKAA',
    },
    {
      displayAs: 'Store Locator',
      redirectTo: 'https://stores.nykaa.com/?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Cancellation & Return',
      redirectTo: '/cancellation-policy/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Shipping & Delivery',
      redirectTo: '/shipping-policy/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Sell on Nykaa',
      redirectTo: '/sellonnykaa',
    },
  ],
  'Inspire Me': [
    {
      displayAs: 'Beauty Book',
      redirectTo:
        'https://www.nykaa.com/beauty-blog/?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Nykaa TV',
      redirectTo:
        'https://nykaatv-web.nykaa.com/?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Nykaa Network',
      redirectTo: 'https://www.nykaa.com/nykaa-network',
    },
    {
      displayAs: 'Buying Guides',
      redirectTo:
        'https://www.nykaa.com/buying-guides/?utm_source=Desktop_web_footer',
    },
  ],
  'Quick Links': [
    {
      displayAs: 'Offer Zone',
      redirectTo: '/offers.html?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'New Launches',
      redirectTo: '/new-at-nykaa?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Nykaa Man',
      redirectTo: 'https://www.nykaaman.com/?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Nykaa Fashion',
      redirectTo: 'https://www.nykaafashion.com/?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Nykaa Pro',
      redirectTo: '/nykaa-pro?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Nykaa femina beauty awards winners 2019',
      redirectTo:
        'https://www.nykaa.com/nfba-nominees-sale-online-2019/?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Sitemap',
      redirectTo: '/sitemap/lp?root=nav_footer',
    },
  ],
  'Top Categories': [
    {
      displayAs: 'Makeup',
      redirectTo: '/makeup.html?root=nav_footer&utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Skin',
      redirectTo:
        '/skin-care.html?root=nav_footer&utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Hair',
      redirectTo:
        '/hair-care.html?root=nav_footer&utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Personal Care',
      redirectTo:
        '/personal-care.html?root=nav_footer&utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Appliances',
      redirectTo:
        '/best-personal-care-appliances-online?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Mom and Baby',
      redirectTo:
        '/mom-and-baby.html?root=nav_footer&utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Wellness',
      redirectTo:
        '/wellness.html?root=nav_footer&utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Fragrance',
      redirectTo:
        '/fragrance.html?root=nav_footer&utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Natura',
      redirectTo: '/natural/c/9564?root=nav_1',
    },
    {
      displayAs: 'Luxe',
      redirectTo: '/luxe-focus?root=nav_footer&utm_source=Desktop_web_footer',
    },
  ],
};

export const MAN_LINKS = {
  NykaaMan: [
    {
      displayAs: 'Who are we?',
      redirectTo: '/who_are_we/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Careers',
      redirectTo: '/who_are_we/lp#wwrcopen',
    },
    {
      displayAs: 'Authenticity',
      redirectTo:
        '/authenticity-nykaa-guarantee/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Press',
      redirectTo: '/who_are_we/lp#wwrpress',
    },
    {
      displayAs: 'Testimonials',
      redirectTo: '/who_are_we/lp#wwrtestimonial',
    },
  ],
  Help: [
    {
      displayAs: 'Contact Us',
      redirectTo:
        'https://www.nykaaman.com/gateway-api/omsApis/helpCenter?domain=NYKAA_MEN',
    },
    {
      displayAs: 'Frequently asked questions',
      redirectTo:
        'https://www.nykaaman.com/gateway-api/omsApis/helpCenter?domain=NYKAA_MEN',
    },
    {
      displayAs: 'Store Locator',
      redirectTo: 'https://stores.nykaa.com/?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Cancellation & Return',
      redirectTo: '/cancellation-policy/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Shipping & delivery policy',
      redirectTo: '/shipping-policy/lp?utm_source=Desktop_web_footer',
    },
  ],
  'Quick Links': [
    {
      displayAs: 'Brand Stores',
      redirectTo: '/brand-directory',
    },
    {
      displayAs: 'Offer Zone',
      redirectTo: '/offers-nykaaman/lp?utm_source=Desktop_web_footer',
    },
    {
      displayAs: 'Sitemap',
      redirectTo: '/sitemap/lp?root=nav_footer',
    },
  ],
  'Top Categories': [
    {
      displayAs: 'Shaving',
      redirectTo: '/nykaa-man/shaving.html?root=nav_footer',
      className: 'double',
    },
    {
      displayAs: 'Beard Care',
      className: 'double',
      redirectTo:
        '/nykaa-man/beard-care.html?root=nav_3&dir=desc&order=popularity',
    },
    {
      displayAs: 'Hair Care',
      className: 'double',
      redirectTo:
        '/nykaa-man/hair-care.html?root=nav_2&dir=desc&order=popularity',
    },
    {
      displayAs: 'Skin Care',
      className: 'double',
      redirectTo: '/mens/skin-care.html?root=nav_2&dir=desc&order=popularity',
    },
    {
      displayAs: 'Personal Care',
      className: 'double',
      redirectTo: '/nykaa-man/personal-care.html?&root=nav_2',
    },
    {
      displayAs: 'Kits & combos',
      className: 'double',
      redirectTo: '/nykaa-man/kits-combos.html?&root=nav_2',
    },
    {
      displayAs: 'Perfumes & Deos',
      className: 'double',
      redirectTo:
        '/nykaa-man/perfumes-deos.html?root=nav_2&dir=desc&order=popularity',
    },
    {
      displayAs: 'Sports Nutrition',
      className: 'double',
      redirectTo:
        '/nykaa-man/sports-nutrition.html?root=nav_3&dir=desc&order=popularity',
    },
    {
      displayAs: 'Wellness',
      className: 'double',
      redirectTo:
        '/nykaa-man/wellness.html?root=nav_2&dir=desc&order=popularity',
    },
    {
      displayAs: 'Gifting',
      className: 'double',
      redirectTo:
        '/nykaa-man/gifting.html?root=nav_2&dir=desc&order=popularity',
    },
  ],
  Luxe: [
    {
      displayAs: 'Bath and Body',
      redirectTo: '/nykaa-man/luxe-man-focus/bath-body.html?root=nav_2',
    },
    {
      displayAs: 'Hair',
      redirectTo: '/nykaa-man/luxe-man-focus/hair.html?root=nav_2',
    },
    {
      displayAs: 'Fragrance',
      redirectTo: '/nykaa-man/luxe-man-focus/fragrance.html?root=nav_2',
    },
    {
      displayAs: 'Skin',
      redirectTo: '/nykaa-man/luxe-man-focus/skin.html?root=nav_2',
    },
  ],
};
